import * as ResultsDataManage from '@Services/ResultsDataManage';
import { handleViewSaveModal } from '@Pages/History/HistoryAction';
import HistoryHelper from '@Services/HistoryHelper/';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfHistorySaveDialog } from '@Pages/History/Constants';
import { baseParamsForSorting as baseParamsForSortingSelector } from './ResultToolbarSelectors';

export function setSorting(value, order) {
  return (dispatch, getState) => {
    const state = getState();
    const baseParamsForSorting = baseParamsForSortingSelector(state);

    const searchParams = {
      ...baseParamsForSorting,
      order,
      sort: value,
      sortChanged: true,
      limitOrExclude: '',
      resetBreadcrumbs: false,
    };

    // Change state to call new results
    return ResultsDataManage.redirectToResults(searchParams);
  };
}

export function editInQueryBuilder(breadcrumbObj) {
  return () => {
    HistoryHelper.copyQuery(breadcrumbObj);
  };
}

export function saveSearch(historyItem) {
  return (dispatch) => {
    dispatch(handleViewSaveModal(true, true, null, null, { ...historyItem }));
    dispatch(
      updateDialog({
        id: typeOfHistorySaveDialog,
        dialogType: typeOfHistorySaveDialog,
      })
    );
  };
}
